<template>
    <div class="staff">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>商品管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>商品审核</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <!--搜索区-->
            <el-card>
                <el-container>
                    <el-aside width="220px" :style="{height: treeConfig.height + 'px', marginRight: '10px'}">
                        <div ref="treePosition"></div>
                        <el-tree size="mini"
                            :load="loadTree"
                            ref="tree"
                            lazy
                            node-key="id"
                            :props="props"
                            :current-node-key="searchForm.categoryId"
                            :highlight-current="true"
                            :expand-on-click-node="false"
                            :default-expanded-keys="['root']"
                            accordion
                            @current-change="changeTreeNode">
                            <div class="custom-tree-node" slot-scope="{ node, data }">
                                <span style="flex-grow: 1; font-size: 12px;">
                                    <span slot="reference"><i v-if="node.data.fid == 'root'" :class="node.data.icon"></i>{{ node.data.name }}</span>
                                </span>
                            </div>
                        </el-tree>
                    </el-aside>
                    <el-main>
                        <el-form :inline="true" :model="searchForm" size="mini">
                            <el-form-item label="SKU">
                                <el-input v-model="searchForm.sku" placeholder="SKU" size="mini" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="商品名称">
                                <el-input v-model="searchForm.name" placeholder="商品名称" size="mini" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="供应商">
                                <el-input v-model="searchForm.supplier" placeholder="请输入供应商" size="mini" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="供应商SKU">
                                <el-input v-model="searchForm.supplierSku" placeholder="请输入供应商SKU" size="mini" clearable></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="状态">
                                <el-select v-model="searchForm.status" placeholder="商品状态" size="mini" clearable>
                                    <el-option label="全部" value=""></el-option>
                                    <el-option label="草稿" value="0"></el-option>
                                    <el-option label="待审核" value="1"></el-option>
                                    <el-option label="部分上架" value="2"></el-option>
                                    <el-option label="上架" value="3"></el-option>
                                    <el-option label="驳回" value="4"></el-option>
                                    <el-option label="待下架" value="5"></el-option>
                                    <el-option label="下架" value="6"></el-option>
                                </el-select>
                            </el-form-item> -->
                            <el-form-item>
                                <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                            </el-form-item>
                        </el-form>
                        <div ref="tablePosition"></div>
                        <!--数据展示区-->
                        <el-table stripe :data="tableData" v-loading="loading" style="width: 100%" size="mini" :height="tableConfig.height" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55" fixed/>
                            <el-table-column prop="sku" label="SKU" width="120" fixed="left"/>
                            <el-table-column prop="name" label="名称" min-width="200"/>
                            <el-table-column prop="brandNameCh" label="品牌" width="100"/>
                            <el-table-column prop="delivery" label="货期(天)" width="80"/>
                            <el-table-column prop="unit" label="单位" width="80"/>
                            <el-table-column prop="supplierOfficialPrice" label="面价(元)" width="120" align="right" :formatter="formatterMoney"/>
                            <el-table-column prop="prevSupplierUntaxedPrice" label="修改前未税采购单价(元)" width="180" align="right" :formatter="formatterMoney"/>
                            <el-table-column prop="supplierUntaxedPrice" label="未税采购单价(元)" width="120" align="right" :formatter="formatterMoney"/>
                            <el-table-column prop="supplierPrice" label="含税采购单价(元)" width="120" align="right" :formatter="formatterMoney"/>
                            <el-table-column label="未税销售单价(元)" align="center" >
                                <el-table-column prop="calcUntaxedPrice" width="90" label="测算价" align="center" :formatter="formatterMoney" ></el-table-column>
                                <el-table-column prop="untaxedPrice" width="90" label="销售价" align="center" :formatter="formatterMoney" ></el-table-column>
                            </el-table-column>
                            <el-table-column label="含税销售单价(元)" align="center" >
                                <el-table-column prop="calcPrice" width="90" label="测算价" align="center" :formatter="formatterMoney" ></el-table-column>
                                <el-table-column prop="price" width="90" label="销售价" align="center" :formatter="formatterMoney" ></el-table-column>
                            </el-table-column>
                            <el-table-column prop="supplier" label="供应商" width="200"/>
                            <el-table-column prop="supplierSku" label="供应商SKU" width="200"/>
                            <el-table-column prop="status" label="状态" width="80">
                                <template slot-scope="scope">
                                    <el-tag type="danger" v-if="scope.row.status == 0">草稿</el-tag>
                                    <el-tag type="warning" v-if="scope.row.status == 1">待审核</el-tag>
                                    <el-tag type="success" v-if="scope.row.status == 2">部分上架</el-tag>
                                    <el-tag type="success" v-if="scope.row.status == 3">上架</el-tag>
                                    <el-tag type="warning" v-if="scope.row.status == 4">驳回</el-tag>
                                    <el-tag type="warning" v-if="scope.row.status == 5">待下架</el-tag>
                                    <el-tag type="info" v-if="scope.row.status == 6">下架</el-tag>
                                    <el-tag type="info" v-if="scope.row.status == 8">待审批</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="200" align="right" fixed="right">
                                <template slot="header" slot-scope="header">
                                    <el-dropdown style="margin-left: 8px;" @command="more">
                                        <el-button type="primary" size="mini">
                                            批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="reject">驳回</el-dropdown-item>
                                            <el-dropdown-item command="pass">通过</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <!-- <el-button type="primary" @click="handleCreate" size="mini">添加</el-button> -->
                                </template>
                                <template slot-scope="scope">
                                    <el-button type="text" size="mini" @click="preview(scope.$index, scope.row)">预览</el-button>
                                    <el-divider direction="vertical" ></el-divider>
                                    <el-button type="text" size="mini" @click="handleReject(scope.$index, scope.row)">驳回</el-button>
                                    <el-divider direction="vertical" ></el-divider>
                                    <el-button type="text" size="mini" @click="handlePass(scope.$index, scope.row)">通过</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div style="text-align: center;padding-top: 20px">
                            <el-pagination
                                    background
                                    layout="sizes,prev, pager, next"
                                    :page-sizes="[10, 20, 50, 100]"
                                    v-if="total>0"
                                    :total="total"
                                    :page-size="pageSize"
                                    @size-change="handleSizeChange"
                                    @current-change="onPageChange"
                                    :current-page="currentPage"
                                    @prev-click="onPageChange"
                                    @next-click="onPageChange">
                            </el-pagination>
                        </div>
                    </el-main>
                </el-container>
            </el-card>
        </main>
        <el-dialog title="设置销售价格" :visible.sync="editPriceDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form :model="editPriceForm" label-width="80px" :rules="editPriceFormRules" ref="editPriceForm">
                <el-form-item label="加点比例" prop="rate">
                    <el-input v-model="editPriceForm.rate" placeholder="请输入加点比例" clearable>
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editPriceDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="doEditPrice">确 定</el-button>
                <el-button type="primary" @click="doEditPrice">确定并通过</el-button>
            </div>
        </el-dialog>
        <el-dialog title="拒绝申请" :visible.sync="rejectDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form :model="rejectForm" label-width="80px">
                <el-form-item label="拒绝原因" prop="reason">
                    <el-input v-model="rejectForm.reason" placeholder="请输入拒绝原因" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="rejectDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onReject">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import store from '../../store';
    const HEIGHT_OFFSET = 118;
    export default {
        data() {
            return {
                pageLoading: undefined,
                tableConfig: {
                    height: 0,
                },
                treeConfig: {
                    height: 0,
                },
                searchForm: {
                    categoryLevel: 0,
                    categoryId: "root",
                    sku: "",
                    name: "",
                    supplier: "",
                    supplierSku: "",
                },
                rejectForm: {
                    id: [],
                    reason: "",
                },
                statusOptions: [
                    {
                        value: "",
                        label: "全部",
                    },
                    {
                        value: "0",
                        label: "下架",
                    },
                    {
                        value: "1",
                        label: "上架",
                    },
                ],
                loading: false,
                total: 0,
                pageSize: 10,
                currentPage: 1,
                tableData: [],
                rejectDialogVisible: false,
                selectData: [],
                editPriceDialogVisible: false,
                editPriceForm: {
                    id: [],
                    rate: "",
                },
                editPriceFormRules: {
                    rate: [
                        { required: true, message: "请输入加点比例", trigger: "blur" },
                        { validator: (rule, value, callback) => {
                            const reg = /^\d*$/;
                            if(reg.test(value)) {
                                callback();
                            } else {
                                callback('请输入有效数字');
                            }
                        }, trigger: 'blur' }
                    ],
                }
            }
        },
        methods: {
            onSearch() {
                let params = {};
                if (this.searchForm.categoryId != "root") {
                    params["categoryId"] = this.searchForm.categoryId;
                }
                if (this.searchForm.name != "") {
                    params["name"] = this.searchForm.name;
                }
                if (this.searchForm.sku != "") {
                    params["sku"] = this.searchForm.sku;
                }
                if (this.searchForm.supplier != "") {
                    params["supplier"] = this.searchForm.supplier;
                }
                if (this.searchForm.supplierSku != "") {
                    params["supplierSku"] = this.searchForm.supplierSku;
                }

                this.loading = true;

                let _this = this
                this.$axios.post("/admin/product/pagePendingManager", {
                    cond: params,
                    page: this.currentPage - 1,size:this.pageSize
                }).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        console.log(resp);
                        _this.loading = false;
                        _this.tableData = resp.data.content;
                        _this.total = resp.data.totalElements;
                    }
                }).catch(function () {
                });
            },
            handleCreate() {
                this.$router.push({ name: "addProduct" });
            },
            handleSizeChange(pageSize){
                this.pageSize = pageSize;
                this.onSearch();
            },
            onPageChange(currentPage) {
                this.currentPage = currentPage;
                this.onSearch();
            },
            handleSelectionChange(val) {
                this.selectData = val;
            },
            preview(index, row) {
                window.open(store.getters.getDomain + "/item?id=" + row.id, "_blank");
            },
            handlePass(index, row) {
                let that = this
                this.$axios.post("/admin/product/managerPass", [row.id],)
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header.status === 0) {
                        that.$notify({
                            title: '成功',
                            message: '审核通过',
                            type: 'success'
                        });
                        that.onSearch();
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                }).catch(function () {
                });
            },
            handleReject(index, row) {
                this.rejectForm.id = [row.id];
                this.rejectForm.reason = "";
                this.rejectDialogVisible = true;
            },

            more(command) {
                const that = this;
                switch(command) {
                    case 'reject':
                        this.rejectForm.id = this.selectData.map(it => it['id']);
                        this.rejectForm.reason = "";
                        this.rejectDialogVisible = true;
                        break;
                    case 'pass':
                        let that = this
                        this.$axios.post("/admin/product/managerPass", this.selectData.map(it => it['id']),)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status === 0) {
                                that.$notify({
                                    title: '成功',
                                    message: '审核通过',
                                    type: 'success'
                                });
                                that.onSearch();
                            } else {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        }).catch(function () {
                        });
                        break;
                }

            },
            onReject() {
                let that = this
                this.$axios.post("/admin/product/managerReject", this.rejectForm)
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header.status === 0) {
                        that.$notify({
                            title: '成功',
                            message: '申请已驳回',
                            type: 'success'
                        });
                        that.onSearch();
                        that.rejectDialogVisible = false;
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                }).catch(function () {
                });
            },
            formatterMoney(row, col, value) {
                if(value) {
                    return this.MoneyFormat(value, "", 2);
                } else {
                    return "-";
                }
            },
            deliveryFormatter(row, column, cellValue) {
                return cellValue ? cellValue + "天" : "未定";
            },
            setTableHeight() {
                const tablePosition = this.$refs['tablePosition'];
                const {top} = tablePosition.getBoundingClientRect();
                this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
            },
            setTreeHeight() {
                const treePosition = this.$refs['treePosition'];
                const {top} = treePosition.getBoundingClientRect();
                this.treeConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
            },
            loadTree(node, resolve) {
                if(node.level === 0) {
                    resolve([{id: "root", name: "全部产品分类", type: 0, description: "", uri: "-", status: 1, level: -1, isLeaf: false}]);
                } else {
                    // this.loading = true;
                    let _this = this;
                    this.$axios.post("/admin/product/category/list", {
                        fid: node.data.id,
                    }).then(function(response) {
                        let resp = response.data;
                        if(resp.header.status == 0) {
                            resolve(resp.data.map(it => ({...it, leaf: (it.children || []).length === 0})));
                        } else {
                            _this.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                        // _this.loading = false;
                    }).catch(function(error) {
                        // _this.loading = false;
                    });
                }
            },
            changeTreeNode(data, node) {
                if(this.searchForm.categoryId !== node.data.id) {
                    this.searchForm.categoryId = node.data.id;
                    this.searchForm.categoryLevel = node.data.level;
                    this.currentPage=1;
                    this.onSearch();
                }
            },
        },
        created() {
            this.onSearch();
            window.addEventListener("resize", this.setTableHeight);
            window.addEventListener("resize", this.setTreeHeight);
        },
        activated() {
            setTimeout(() => {
                this.setTableHeight();
                this.setTreeHeight();
            }, 500);
        },
        mounted() {
            setTimeout(() => {
                this.setTableHeight();
                this.setTreeHeight();
            }, 500);
        },
        destroyed () {
            window.removeEventListener("resize", this.setTableHeight);
            window.removeEventListener("resize", this.setTreeHeight);
        },
        // created() {
        //     this.onSearch()
        //     window.addEventListener("resize", this.setTableHeight);
        //     window.addEventListener("resize", this.setTreeHeight);
        // },
        // mounted() {
        //     this.pageLoading = this.$loading({
        //         lock: true,
        //         text: 'Loading',
        //         spinner: 'el-icon-loading',
        //         background: 'rgba(0, 0, 0, 0.7)'
        //     });
        //     setTimeout(() => {
        //         this.setTreeHeight();
        //         this.setTableHeight();
        //         this.pageLoading.close();
        //         this.pageLoading = undefined;
        //     }, 500);
        // },
        // beforeDestroy() {
        //     if(this.pageLoading){
        //         this.pageLoading.close();
        //         this.pageLoading = undefined;
        //     }
        // },
        // destroyed () {
        //     window.removeEventListener("resize", this.setTableHeight);
        //     window.removeEventListener("resize", this.setTreeHeight);
        // }
    }
</script>
<style>
</style>
